"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    announcements: {
        en: 'Announcements',
        es: 'Comunicados'
    },
    announcement: {
        en: 'Announcement',
        es: 'Comunicado'
    },
    newAnnouncement: {
        en: 'New Announcement',
        es: 'Nuevo Comunicado'
    },
    editAnnouncement: {
        en: 'Edit Announcement',
        es: 'Editar Comunicado'
    },
    viewAnnouncement: {
        en: 'View Announcement',
        es: 'Ver Comunicado'
    },
    deleteAnnouncement: {
        en: 'Delete Announcement?',
        es: '¿Eliminar Comunicado?'
    },
    deleteAnnouncementDescription: {
        en: 'This action can not be undone. Once deleted, the banner will be removed if it was being displayed.',
        es: 'Esta acción no se puede deshacer. Una vez eliminado, el banner se quitará si estaba siendo mostrado.'
    },
    deleteAnnouncementSuccessful: {
        en: 'The announcement was successfully deleted',
        es: 'El comunicado fue eliminado con éxito'
    },
    infoAnnouncement: {
        en: 'Information',
        es: 'Informativo'
    },
    warningAnnouncement: {
        en: 'Warning',
        es: 'Alerta'
    },
    announcementSavedSuccess: {
        en: 'Announcement saved successfully',
        es: 'Comunicado guardado con éxito'
    },
    announcementFirstPreview: {
        en: 'A preview of this announcement will be shown at the top of the app.',
        es: 'Se mostrará una vista previa de este anuncio en la parte superior de la aplicación.'
    },
    announcementStartsAt: {
        en: "Starts At",
        es: "Inicia",
    },
    announcementendsAt: {
        en: "Ends At",
        es: "Termina",
    },
    announcementSecondPreview: {
        en: 'This is what your clients will see.',
        es: 'Esto es lo que verán tus clientes.'
    },
    announcementTypePlaceholder: {
        en: "Select a type",
        es: "Seleccione un tipo"
    },
    selectCarrier: {
        en: 'Select a Carrier',
        es: 'Seleccione un Proveedor'
    },
    publish: {
        en: 'Publish',
        es: 'Publicar',
    },
    takeDown: {
        en: 'Turn to draft',
        es: 'Convertir a borrador',
    },
    selectAllCarriers: {
        en: 'All clients',
        es: 'Todos los clientes'
    },
    targetAudience: {
        en: 'Target Audience',
        es: 'Audiencia Objetivo'
    },
    noCarrierSelected: {
        en: 'No carrier selected.',
        es: 'Ningún proveedor seleccionado.'
    },
    allCarriersSelected: {
        en: 'Targeting all carriers',
        es: 'Dirigido a todos los proveedores'
    }
};
exports.default = translations;
